import {
  actionTypes,
  officeRequestSuccess,
  officeRequestFailure,
  brByOfficeRequestSuccess,
  brByOfficeRequestFailure,
  entitlementByOURequestSuccess,
  entitlementByOURequestFailure,
  createBRRequestSuccess,
  createBRRequestFailure,
  modifyBRRequestSuccess,
  modifyBRRequestFailure,
  deleteBRRequestFailure,
  deleteBRRequestSuccess,
  sodConflictsActionBRSuccess,
  sodConflictsActionBRFailure,
  getBrEntitlementsActionSuccess,
  getBrEntitlementsActionFailure,
} from "./actions";

import {
  fetchOfficeRequest,
  fetchBRByOfficeRequest,
  fetchEntitlementsByOuRequest,
  createBRRequest,
  modifyBRRequest,
  fetchDeleteBRRequest,
  getBrEntitlements,
} from "./services";
import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import { fetchSODConflictsBR } from "../../../common/SODUtils/SODservices";

const fetchOfficeRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.OFFICE_REQUEST_BR_MANAGEMENT),
    mergeMap(() =>
      fetchOfficeRequest().pipe(
        map((response: any) => officeRequestSuccess(response)),
        catchError((error: any) => of(officeRequestFailure(error)))
      )
    )
  );

const fetchBRByOfficeRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.BR_BY_OFFICE_REQUEST),
    mergeMap((action: any) =>
      fetchBRByOfficeRequest(action.payload).pipe(
        map((response: any) => brByOfficeRequestSuccess(response)),
        catchError((error: any) => of(brByOfficeRequestFailure(error)))
      )
    )
  );

const fetchEntitlementByOURequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ENTITLEMENT_BY_OU_REQUEST),
    mergeMap((action: any) =>
      fetchEntitlementsByOuRequest(action.payload).pipe(
        map((response: any) => entitlementByOURequestSuccess(response)),
        catchError((error: any) => of(entitlementByOURequestFailure(error)))
      )
    )
  );

const createBRRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_BR_REQUEST),
    mergeMap((action: any) =>
      createBRRequest(action.payload).pipe(
        map((response: any) => createBRRequestSuccess(response)),
        catchError((error: any) => of(createBRRequestFailure(error)))
      )
    )
  );

const modifyBRRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.MODIFY_BR_REQUEST),
    mergeMap((action: any) =>
      modifyBRRequest(action.payload).pipe(
        map((response: any) => modifyBRRequestSuccess(response)),
        catchError((error: any) => of(modifyBRRequestFailure(error)))
      )
    )
  );

const deleteBRRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_BR_REQUEST),
    mergeMap((action: any) =>
      fetchDeleteBRRequest(action.payload, action.formdata).pipe(
        map((response: any) => deleteBRRequestSuccess(response)),
        catchError((error: any) => of(deleteBRRequestFailure(error)))
      )
    )
  );

const fetchSODConflictsBREpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SOD_CONFLICTS_BR),
    mergeMap((action: any) =>
      fetchSODConflictsBR(action.payload).pipe(
        map((response: any) => sodConflictsActionBRSuccess(response)),
        catchError((error: any) => of(sodConflictsActionBRFailure(error)))
      )
    )
  );

const getBrEntitlementsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_BR_ENTITLEMENTS),
    mergeMap((action: any) =>
      getBrEntitlements(action.payload).pipe(
        map((response: any) => getBrEntitlementsActionSuccess(response)),
        catchError((error: any) => of(getBrEntitlementsActionFailure(error)))
      )
    )
  );

export default [
  fetchOfficeRequestEpic,
  fetchBRByOfficeRequestEpic,
  fetchEntitlementByOURequestEpic,
  createBRRequestEpic,
  modifyBRRequestEpic,
  deleteBRRequestEpic,
  fetchSODConflictsBREpic,
  getBrEntitlementsEpic,
];
